export default "__VITE_ASSET__B4WIxfb8__"